import React, { useState, useEffect, useContext } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import { Link } from "gatsby"

import icon from "src/images/icon.png"
import User from "src/images/button-icon-user.svg"
import Menu from "src/images/button-icon-menu.svg"
import ShoppingCart from "src/images/button-icon-shopping-cart.svg"
import Button from "src/components/core/atoms/button"

import {
  header, offTop, headerContent, headerSide,
  icon as s_icon, headerCentered
} from "./header.module.css"

import { CartContext } from "src/context/CartContext"
import { UserContext } from "src/context/UserContext"

const Header = ( { siteTitle } ) => {
  const [ onPageTop, setOnPageTop ] = useState( false )
  const { cartData, dispatchSidebar, ACTIONS } = useContext( CartContext )
  const { authUser, signOut } = useContext( UserContext )

  useEffect( () => {
    const body = document.querySelector( "body" )
    body.onscroll = e => {
      if ( e.currentTarget.scrollY >= 10 ) {
        setOnPageTop( true )
      } else {
        setOnPageTop( false )
      }
    }
  }, [] )

  return (
    <header
      className={ classnames( header, { [ offTop ]: onPageTop } ) }
    >
      <div className={ headerContent }>
        <h1 className={ headerSide }>
          <span show="sm">
            <Button
              variant="underlined"
              onClick={ () => {
                dispatchSidebar( { type: ACTIONS.MENU_IS_OPEN, payload: true } )
              } }
              leftIcon={ <img src={ Menu } alt="menu" /> }
            />
          </span>
          <Link to="/">
            <img className={ s_icon } src={ icon } alt={ siteTitle } />
          </Link>
        </h1>
        <div className={ headerCentered }>
          <span show="lg">
            <Button variant="link" to="/about-us">
              About Us
            </Button>
            <Button variant="link" to="/services">
              Services
            </Button>
            <Button variant="link" to="/contact-us">
              Contact Us
            </Button>
          </span>
        </div>
        <div className={ headerSide } >
          <span show="lg">
            <Button
              variant="link"
              leftIcon={ <img src={ User } alt="user" /> }
              to={ authUser ? "/user/dashboard" : "/login" }
            >
              { authUser ? (
                <span>
                  {authUser.displayName } (
                  <Button variant="underlined" onClick={ signOut }>
                    Sign out
                </Button>
                )
                </span>
              ) : (
                "Log in"
              ) }
            </Button>
          </span>
          <Button
            variant="solid"
            leftIcon={ <img src={ ShoppingCart } alt="shopping cart" /> }
            onClick={ () => dispatchSidebar( { type: ACTIONS.SIDEBAR_IS_OPEN, payload: true } ) }
          >
            My Booking ({ cartData && cartData.length })
          </Button>
        </div>
      </div>
    </header>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
